<template lang="pug">
  div.inactive-goal-container( v-if="goal" @click="changeUnactiveGoal(goal)" )
    div.goal-description
      goal-icon( :title="goal.title" :height="48" :width="48" )
      div.goal-title
        span.text-16-b {{ goal.title }}
        span.price.text-14 Цель: {{ returnMaskPrice(goal.full_amount) }} {{ convertToValueLabel('RUR') }}
      div.percent
        span.text-14-b {{ goalPercent }}%
      img.ml-2( v-if="iconButton" src="@/assets/goalIcon/pencil.svg" @click="editGoal(goal)" )
    v-progress-linear.mt-6(
      :value="goalPercent"
      height="8"
      background-color="#E5E7EB"
      color="orange"
      rounded
      striped
    )
    div.progress-progress-details.price
      span.text-14 Накоплено: {{ returnMaskPrice(goal.accumulated_amount) }} {{ convertToValueLabel('RUR') }}
      span.text-14.ml-auto Осталось: {{ returnMaskPrice(remainingAmount) }} {{ convertToValueLabel('RUR') }}
  div( v-else )
    span.no-inactiveGoals У вас нет неактивных целей
      
</template>

<script>
export default {
  name: 'InActiveGoalBlock',

  props: {
    buttonDisabled: null,
    goal: null,
    iconButton: null
  },

  computed: {
    remainingAmount() {
      return this.goal.full_amount - this.goal.accumulated_amount
    },

    goalPercent() {
      return Math.round((this.goal.accumulated_amount/this.goal.full_amount) * 100)
    },
  },
  methods: {
    returnMaskPrice(value) {
      return value.toLocaleString("ru-RU").replace(/\s/g, ",")
    },
    editGoal(goal) {
      this.$emit('editGoal', goal)
    },

    changeUnactiveGoal(goal) {
      this.$emit('changeUnactiveGoal', goal)
    }
  }
}

</script>
<style scoped>
.inactive-goal-container {
  display: flex;
  flex-direction: column;
  padding: 12px 20px;
  box-shadow: 0px 1px 2px 0px #0000000D;
  border: 1px solid #F3F4F6;
  border-width: 1px;
  border-radius: 16px;

}
.goal-description {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.goal-title {
  margin-left: 16px;
  display: flex;
  flex-direction: column;
}
.price {
  color: #6B7280;
}
.percent {
  margin-left: auto;
  color: #5365E5;
}
.progress-progress-details {
  display: flex;
  flex-direction: row;
  margin-top: 14px;
}
.no-inactiveGoals {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
